export default __webpack_public_path__ + "static/media/logo.02880d72.png";